import { render, staticRenderFns } from "./RenewRecord.vue?vue&type=template&id=8f24cfa2&scoped=true&"
import script from "./RenewRecord.vue?vue&type=script&lang=js&"
export * from "./RenewRecord.vue?vue&type=script&lang=js&"
import style0 from "./RenewRecord.vue?vue&type=style&index=0&id=8f24cfa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f24cfa2",
  null
  
)

export default component.exports